import React from "react";
import { AiOutlineFacebook } from "react-icons/ai";
import { RiWhatsappLine, RiYoutubeLine } from "react-icons/ri";
const Footer = () => {
	return (
		<footer className="bg--section">
			<div className="footer-top">
				<div className="container">
					<div className="footer-top-wrapper">
						<div className="footer-widget widget-links">
							<h5 className="title">About</h5>
							<ul>
								<li>
									<a href="/#">Website</a>
								</li>
								<li>
									<a href="/#">White Paper</a>
								</li>
								<li>
									<a href="/#">Audit</a>
								</li>
								<li>
									<a href="/#">Pitch Deck</a>
								</li>
							</ul>
						</div>
						<div className="footer-widget widget-links">
							<h5 className="title">Development</h5>
							<ul>
								<li>
									<a href="/#">GitHub</a>
								</li>
								<li>
									<a href="/#">Report issue</a>
								</li>
							</ul>
						</div>
						<div className="footer-widget widget-links">
							<h5 className="title">Support</h5>
							<ul>
								<li>
									<a href="/#">Telegram Support</a>
								</li>
							</ul>
						</div>
						<div className="footer-widget widget-newsletter">
							<h5 className="title">Newsletter</h5>
							<p>
								Be the first one to know about discounts, offers and
								events. Unsubscribe whenever you like.
							</p>
							<form className="newsletter-form">
								<input
									type="text"
									className="form-control"
									placeholder="Enter Your Email"
									required=""
									name="email"
								/>
								<button type="submit" className="cmn--btn">
									Subscribe
								</button>
							</form>
							<ul className="social-icons">
								<li>
									<a href="/#">
										<AiOutlineFacebook />
									</a>
								</li>
								<li>
									<a href="/#">
										<RiYoutubeLine />
									</a>
								</li>
								<li>
									<a href="/#">
										<RiWhatsappLine />
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="footer-bottom pb-5 text-center">
				<div className="container">
					&copy; 2000-2021, All Rights Reserved
				</div>
			</div>
		</footer>
	);
};

export default Footer;
